export const APP_STORE_SMART_LINK = 'https://mcdonaldsau.smart.link/da3vsnxur';
